// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3126":"bcb1dc65","4071":"435b8d2d"}[chunkId] + ".chunk.css";
};